import { ContactTypes } from '@src/utils/enums';

type VcContact = {
  contactType: ContactTypes;
  [key: string]: unknown;
};

type VcPayload = {
  request?: {
    contacts?: VcContact[];
    violationComplaints?: Array<{
      isAllegedViolatorKnown?: string | boolean;
      contacts?: VcContact[];
    }>;
  };
};

const suspectTypes = [ContactTypes.SuspectPropertyOwner, ContactTypes.SuspectOther, ContactTypes.SuspectContractor];

const filterOutSuspects = (contacts: VcContact[]): VcContact[] =>
  contacts.filter((contact: VcContact) => !suspectTypes.includes(contact.contactType));

export const formatVcPayload = (payload: VcPayload) => {
  if (
    payload?.request?.violationComplaints?.[0]?.contacts &&
    payload?.request?.violationComplaints?.[0]?.isAllegedViolatorKnown === false
  ) {
    return {
      ...payload,
      request: {
        ...payload.request,
        contacts: payload.request.contacts ? filterOutSuspects(payload.request.contacts) : undefined,
        violationComplaints: [
          {
            ...payload.request.violationComplaints[0],
            contacts: filterOutSuspects(payload.request.violationComplaints[0].contacts),
          },
        ],
      },
    };
  }
  return payload;
};
